import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/ProductListOnDisplay';

const GetProductListReducer = handleActions({
    [Actions.getProductListOnDisplayByCompanyRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getProductListOnDisplayByCompanyReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.getProductListOnDisplayByCompanyReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.getProductListOnDisplayByCompanyClear]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: undefined,
});

const CreateBusinessContactReducer = handleActions({

    [Actions.createBusinessContact]: (state) => ({
        ...state,
        isFetching: true,
    }),

    [Actions.createBusinessContactReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        success: action.payload.message,
    }),

    [Actions.createBusinessContactReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: true,
        errors: action.payload.errors,
        success: '',
    }),

    [Actions.clearBusinessContact]: (state) => ({
        ...state,
        isFetching: false,
        success: '',
        errors: {},
    }),

}, {
    isFetching: false,
    success: '',
    errors: {},
});

const CreateAnonymousBusinessContactReducer = handleActions({
    [Actions.createAnonymousBusinessContact]: (state) => ({
        ...state,
        isFetching: true,
    }),

    [Actions.createAnonymousBusinessContactReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        success: action.payload.message,
    }),

    [Actions.createAnonymousBusinessContactReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: true,
        errors: action.payload.errors,
        success: '',
    }),

    [Actions.clearAnonymousBusinessContact]: (state) => ({
        ...state,
        isFetching: false,
        success: '',
        errors: {},
    }),

}, {
    isFetching: false,
    success: '',
    errors: {},
});

const SendBusinessCardReducer = handleActions({
    [Actions.exchangeBusinessCardRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.exchangeBusinessCardReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        success: action.payload.message,
    }),
    [Actions.exchangeBusinessCardReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        success: '',
        errors: action.payload.errors,
    }),
    [Actions.clearExchangeBusinessCard]: (state) => ({
        ...state,
        isFetching: false,
        success: '',
        errors: {},
    }),
}, {
    isFetching: false,
    success: '',
    errors: {},
});

const UserProfileReducer = handleActions({
    [Actions.getUserProfileRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getUserProfileReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.getUserProfileReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.clearGetUserProfile]: (state) => ({
        ...state,
        isFetching: false,
        data: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const GetBusinessCardReducer = handleActions({
    [Actions.GetExchangeBusinessCardRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetExchangeBusinessCardReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetExchangeBusinessCardReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearGetExchangeBusinessCard]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload,
        data: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const CompanyIdsReducer = handleActions({
    [Actions.getCompanyIdsByEventRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getCompanyIdsByEventReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.getCompanyIdsByEventReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
}, {
    isFetching: false,
    data: [],
    errors: {},
});

const AddToCartReducer = handleActions({
    [Actions.addProductsToCartRequested]: (state) => ({
        ...state,
        isFetching: true,
        success: false,
    }),
    [Actions.addProductsToCartReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        success: true,
        data: action.payload,
    }),
    [Actions.addProductsToCartReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.clearProductsAddToCart]: () => ({
        isFetching: false,
        success: false,
        data: [],
        errors: {},
    }),
}, {
    isFetching: false,
    success: false,
    data: [],
    errors: {},
});

export default combineReducers({
    getList: GetProductListReducer,
    createContact: CreateBusinessContactReducer,
    createAnonymousContact: CreateAnonymousBusinessContactReducer,
    sendBusinessCard: SendBusinessCardReducer,
    getBusinessCard: GetBusinessCardReducer,
    userProfile: UserProfileReducer,
    companyIds: CompanyIdsReducer,
    addToCart: AddToCartReducer,
});
